export const SUBJECT_COLORS = {
  Matematica: "bg-blue-500/10 text-blue-600 dark:bg-blue-500/20 dark:text-blue-300",
  Italiano: "bg-amber-500/10 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300",
  Inglese: "bg-emerald-500/10 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300",
  Fisica: "bg-purple-500/10 text-purple-600 dark:bg-purple-500/20 dark:text-purple-300",
  Storia: "bg-rose-500/10 text-rose-600 dark:bg-rose-500/20 dark:text-rose-300",
  Filosofia: "bg-indigo-500/10 text-indigo-600 dark:bg-indigo-500/20 dark:text-indigo-300",
  Scienze: "bg-teal-500/10 text-teal-700 dark:bg-teal-500/20 dark:text-teal-300",
  Arte: "bg-pink-500/10 text-pink-600 dark:bg-pink-500/20 dark:text-pink-300",
  "Ed. Fisica": "bg-orange-500/10 text-orange-700 dark:bg-orange-500/20 dark:text-orange-300",
  Informatica: "bg-cyan-500/10 text-cyan-700 dark:bg-cyan-500/20 dark:text-cyan-300",
  Latino: "bg-lime-500/10 text-lime-700 dark:bg-lime-500/20 dark:text-lime-300",
  Geografia: "bg-sky-500/10 text-sky-700 dark:bg-sky-500/20 dark:text-sky-300",
  Religione: "bg-yellow-500/10 text-yellow-700 dark:bg-yellow-500/20 dark:text-yellow-300",
  "Ed. Civica": "bg-fuchsia-500/10 text-fuchsia-700 dark:bg-fuchsia-500/20 dark:text-fuchsia-300",
};

export const SUBJECTS = Object.keys(SUBJECT_COLORS).concat(["Altro"]);

export const subjectClass = (s) => SUBJECT_COLORS[s] || "bg-slate-500/10 text-slate-600 dark:bg-slate-500/20 dark:text-slate-300";
